import type { TAnalyticArgs, TAnalytics } from '../types';
import { logMatomoEvent } from '../MatomoContainer';
import { logMetricaEvent } from '../Metrica';

// TODO: write unit tests for it
export const logEvent = <K extends keyof TAnalytics>(
  event: K,
  ...params: TAnalytics[K] extends undefined | null
    ? [undefined?]
    : [TAnalytics[K]]
) => {
  logMetricaEvent(event, ...params);
  logMatomoEvent(event, ...params);
};

export const logEventAsArray = (analytics?: TAnalyticArgs) => {
  if (!Array.isArray(analytics)) {
    return;
  }
  logEvent(analytics[0], analytics[1]!);
};
